import { Star } from "lucide-react";

const reviews = [
  {
    name: "Hrushikesh Rajankar",
    role: "Home Cleaning",
    initial: "H",
    color: "bg-violet-500",
    stars: 5,
    text:
      "I recently booked a home cleaning service with Shine Express, and I am extremely satisfied with the results. The team arrived on time, was professional, and paid great attention to detail. Every corner of my home was thoroughly cleaned, and they made sure everything was spotless and well-organized before leaving. Highly recommend!",
  },
  {
    name: "Rutuja Dhanorkar",
    role: "Solar Panel Cleaning",
    initial: "R",
    color: "bg-slate-500",
    stars: 5,
    text:
      "I recently used Shine Express for solar panel cleaning, and I'm extremely satisfied with their service. The team was punctual, professional, and very thorough. Their attention to detail and commitment to quality truly stood out. I will definitely be using their services again!",
  },
  {
    name: "Shweta Tayade",
    role: "Car & Sofa Cleaning",
    initial: "S",
    color: "bg-pink-500",
    stars: 5,
    text:
      "I recently availed their car cleaning and sofa cleaning services, and I am extremely happy. My car interior looks spotless and fresh, and the sofa cleaning was equally impressive — all stains and dust were removed carefully without damaging the fabric. Highly recommended!",
  },
  {
    name: "Poonam Harne",
    role: "Tank Cleaning",
    initial: "P",
    color: "bg-sky-500",
    stars: 5,
    text:
      "Shine Xpress cleaned the water tank at my home — it looks new after cleaning. Thank you for the best service!",
  },
  {
    name: "Mangesh Ingole",
    role: "Verified Customer",
    initial: "M",
    color: "bg-amber-700",
    stars: 5,
    text: "Nice working team and clean service. 😊",
  },
  {
    name: "Siddesh Chandekar",
    role: "Verified Customer",
    initial: "S",
    color: "bg-slate-600",
    stars: 5,
    text:
      "Great experience with Shine Express. Professional team and thorough work — would recommend.",
  },
];

function Stars({ count }) {
  return (
    <div className="flex items-center gap-0.5 text-amber-500">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className={`h-4 w-4 ${i < count ? "fill-current" : "text-slate-200 fill-current"}`} />
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 md:py-28 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div className="max-w-2xl">
            <span className="text-xs font-bold uppercase tracking-[0.15em] text-sky-600">Reviews from Google</span>
            <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
              Loved by families, societies & car owners.
            </h2>
          </div>
          <div className="flex items-center gap-3 rounded-2xl border border-slate-100 bg-slate-50 px-5 py-3" data-testid="google-rating-badge">
            <svg className="h-7 w-7" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.3-.4-3.5z"/>
              <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.6 8.4 6.3 14.7z"/>
              <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.3 35 26.8 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.6 5.1C9.5 39.5 16.2 44 24 44z"/>
              <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.1 5.6l6.2 5.2C41.4 36 44 30.5 44 24c0-1.3-.1-2.3-.4-3.5z"/>
            </svg>
            <div>
              <div className="flex items-center gap-1">
                <Stars count={5} />
                <span className="ml-2 font-display font-bold text-slate-900">5.0</span>
              </div>
              <p className="text-xs text-slate-500">Based on verified Google reviews</p>
            </div>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <figure
              key={i}
              className="card-soft rounded-2xl p-7 flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <div className="flex items-center justify-between mb-4">
                <Stars count={r.stars} />
                <span className="text-xs font-semibold text-sky-600">{r.role}</span>
              </div>
              <blockquote className="text-slate-700 leading-relaxed flex-1 text-sm">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <span className={`h-10 w-10 rounded-full ${r.color} text-white flex items-center justify-center font-semibold`}>
                  {r.initial}
                </span>
                <div>
                  <p className="font-display font-semibold text-slate-900 text-sm">{r.name}</p>
                  <p className="text-xs text-slate-500">Verified Google review</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
